import { Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../customers/customer.service';
import { SelectedCustomer } from '../models/customer';
import { BatteryService } from './battery.service';
import { VehicleMake, VehicleModel, VehicleVariant, VariantBattery } from '../models/battery';
import { NotificationService } from '../shared/notification.service';
import { Subscription } from 'rxjs';
import { RecentSearch } from '../models/recent-search';
import { SearchType } from '../models/search';
import { SearchbarComponent } from '../searchbar/searchbar.component';
import { RecentSearchService } from './recent-search.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})


export class SearchComponent implements OnInit, OnDestroy {

   @ViewChild(SearchbarComponent) searchbar?: SearchbarComponent;

   //Visual Effects
   isShopping = false;
   isQuote = false
   public isBatteryFinderModalVisible = false;
   public recentCustomerSearches: RecentSearch[] = [];
   public relativeTimeReference = Date.now();
   private recentSearchSubscription?: Subscription;
   private relativeTimeTimer?: ReturnType<typeof setInterval>;

   // Battery Finder Modal
   selectedVehicleMake: number | null = null;
   selectedVehicleModel: number | null = null;
   selectedVehicleVariant: number | null = null;
   
   vehicleMakes: VehicleMake[] = [];
   vehicleModels: VehicleModel[] = [];
   vehicleVariants: VehicleVariant[] = [];

   loadingMakes = false;
   loadingModels = false;
   loadingVariants = false;
   loadingBatteries = false;

   selectedVariantDetails: VehicleVariant | null = null;
   variantBatteries: VariantBattery[] = [];

  constructor(private router: Router, private customerService: CustomerService, private batteryService: BatteryService, private notification: NotificationService, private recentSearchService: RecentSearchService) { }

  ngOnInit()
  {

    this.recentSearchSubscription = this.recentSearchService.recentSearches$.subscribe(searches => {
      this.recentCustomerSearches = searches.filter(search => search.searchType === SearchType.Customer);
      this.relativeTimeReference = Date.now();
    });
    this.relativeTimeTimer = setInterval(() => {
      this.relativeTimeReference = Date.now();
    }, 60000);

    //Check if Already Shopping
    for (var i = 0; i < sessionStorage.length; i++)
	  {
      var Cart = JSON.parse(sessionStorage.getItem('Cart')!) as any[];
      if( Cart != null)
      {
        this.isShopping = true;
      }
    }

    //If we were busy working with a customer, remove the link. This might need to be changed in the future.
    this.customerService.selectedCustomer = new SelectedCustomer();

  }

  ngOnDestroy(): void {
    this.recentSearchSubscription?.unsubscribe();
    if (this.relativeTimeTimer) {
      clearInterval(this.relativeTimeTimer);
    }
  }

  repeatRecentSearch(search: RecentSearch): void {
    this.searchbar?.repeatRecentSearch(search);
  }

  getRelativeTime(searchedAt: number): string {
    const minutesAgo = Math.max(0, Math.floor((this.relativeTimeReference - searchedAt) / 60000));

    if (minutesAgo === 0) {
      return 'just now';
    }
    if (minutesAgo === 1) {
      return '1 min ago';
    }
    return `${minutesAgo} mins ago`;
  }

  openCart() {
    this.router.navigate(['/stock/order']);
  }

  onBatteryFinder() {
    this.isBatteryFinderModalVisible = true;
    this.loadVehicleMakes();
  }

  onTruckTyres() {
    // TODO: Show info on truck tyres
    console.log('Truck Tyres clicked');
  }

  onWhatsNew() {
    // TODO: IDisplay news section or sommin?
    console.log('Whats New clicked');
  }

  handleBatteryFinderCancel() {
    this.isBatteryFinderModalVisible = false;
    this.resetBatteryFinderForm();
  }

  handleBatteryFinderOk() {
    console.log('Battery Finder - Selected Make:', this.selectedVehicleMake);
    console.log('Battery Finder - Selected Model:', this.selectedVehicleModel);
    console.log('Battery Finder - Selected Variant:', this.selectedVehicleVariant);
    // TODO: Implement battery search logic here
    this.isBatteryFinderModalVisible = false;
  }

  resetBatteryFinderForm() {
    this.selectedVehicleMake = null;
    this.selectedVehicleModel = null;
    this.selectedVehicleVariant = null;
    this.vehicleModels = [];
    this.vehicleVariants = [];
    this.selectedVariantDetails = null;
    this.variantBatteries = [];
  }

  loadVehicleMakes() {
    this.loadingMakes = true;
    this.batteryService.getVehicleMakes().subscribe({
      next: (makes) => {
        this.vehicleMakes = makes;
        this.loadingMakes = false;
      },
      error: (error) => {
        this.notification.showError('Error loading vehicle makes:', error);
        this.loadingMakes = false;
      }
    });
  }

  onMakeChange(makeId: number | null) {
    this.selectedVehicleModel = null;
    this.selectedVehicleVariant = null;
    this.vehicleModels = [];
    this.vehicleVariants = [];
    
    if (makeId) {
      this.loadingModels = true;
      this.batteryService.getVehicleModels(makeId).subscribe({
        next: (models) => {
          this.vehicleModels = models;
          this.loadingModels = false;
        },
        error: (error) => {
          this.notification.showError('Error loading vehicle models:', error);
          this.loadingModels = false;
        }
      });
    }
  }

  onModelChange(modelId: number | null) {
    this.selectedVehicleVariant = null;
    this.vehicleVariants = [];
    this.selectedVariantDetails = null;
    
    if (modelId) {
      this.loadingVariants = true;
      this.batteryService.getVehicleVariants(modelId).subscribe({
        next: (variants) => {
          this.vehicleVariants = variants;
          this.loadingVariants = false;
        },
        error: (error) => {
          this.notification.showError('Error loading vehicle variants:', error);
          this.loadingVariants = false;
        }
      });
    }
  }

  onVariantChange(variantId: number | null) {
    this.variantBatteries = [];
    
    if (variantId) {
      this.selectedVariantDetails = this.vehicleVariants.find(v => v.variantId === variantId) || null;
      
      // Load battery options for this variant
      this.loadingBatteries = true;
      this.batteryService.getVariantBattery(variantId).subscribe({
        next: (batteries) => {
          this.variantBatteries = batteries;
          this.loadingBatteries = false;
        },
        error: (error) => {
          this.notification.showError('Error loading batteries:', error);
          this.loadingBatteries = false;
        }
      });
    } else {
      this.selectedVariantDetails = null;
    }
  }

  getBatteryStarRating(priority: number | null | undefined): number {
    if (!priority) return 0;
    // Priority 1 = 5 stars, Priority 2 = 4 stars, Priority 3 = 3 stars
    return Math.max(0, 6 - priority);
  }

  searchBattery(battery: VariantBattery) {
    
    // Close the modal
    this.isBatteryFinderModalVisible = false;
    localStorage.removeItem("search");
    localStorage.removeItem("searchType");
    localStorage.setItem("search", battery.msfId?.toString() || '');
    localStorage.setItem("searchType", "2");
    this.router.navigate(['/stock/order']);
    return;
  }

}
